import { ContentBlockType, DataDisplayBlock } from '../../../model';

export const DATA_DISPLAY_NODE_NAME = 'dataDisplay';

export const DEFAULT_DATA_DISPLAY_PROPS: Omit<DataDisplayBlock, 'id'> = {
  type: ContentBlockType.DataDisplay,
  data: '',
};
